var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-app",
    {
      staticStyle: { "margin-top": "-20px", "margin-bottom": "-20px" },
      attrs: { "sticky-container": "", fluid: "" }
    },
    [
      _c(
        "a",
        { staticClass: "co-skip-link", attrs: { href: "#main-content" } },
        [_vm._v("Skip to main content")]
      ),
      _c(
        "nav",
        {
          staticClass: "co-shortcut-nav sr-only",
          attrs: { "aria-label": "Page shortcuts" }
        },
        [
          _c("ul", [
            _c(
              "li",
              [_c("router-link", { attrs: { to: "/" } }, [_vm._v("Home")])],
              1
            ),
            _c(
              "li",
              [
                _c("router-link", { attrs: { to: "/reserve" } }, [
                  _vm._v("Reserve a room")
                ])
              ],
              1
            ),
            _c(
              "li",
              [
                _c("router-link", { attrs: { to: "/attend" } }, [
                  _vm._v("Events")
                ])
              ],
              1
            ),
            _c("li", [
              _c("a", { attrs: { href: "#main-content" } }, [
                _vm._v("Skip to main content")
              ])
            ])
          ])
        ]
      ),
      _c("v-row", [!_vm.embedded ? _c("co-header") : _vm._e()], 1),
      _c(
        "v-content",
        {
          staticClass: "content mx-auto",
          attrs: {
            id: "main-content",
            tabindex: "-1",
            "aria-label": _vm.routeHeading
          }
        },
        [
          _c("h1", { staticClass: "sr-only" }, [
            _vm._v(_vm._s(_vm.routeHeading))
          ]),
          _c("router-view")
        ],
        1
      ),
      _c("v-row", [!_vm.embedded ? _c("co-footer") : _vm._e()], 1)
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }